import React from 'react'
// libs
import styled from 'styled-components'
// hooks
import { useShowModal } from 'hooks'
import { useMediaQuery } from '@mui/material'
// components
import { IconButton } from 'components/UI'
// constants
import { Modals } from 'constants/modals'
import { SCREEN_SIZE } from 'constants/screenSize'
// static
import SystemProcessesIconOrigin from '@mui/icons-material/Cached'
// themes
import colors from 'themes/colors'
// utils
import { size } from 'polished'

const SystemProcessesIcon = styled(SystemProcessesIconOrigin)`
  && {
    ${size('24px')};
    fill: ${colors.white};
  }
`

const AddSystemProcessesButton: React.FC = () => {
  const { showModal } = useShowModal({ modalType: Modals.RISK_TEMPLATE_SYSTEM_PROCESSES_MODAL })

  const isTablet = useMediaQuery(SCREEN_SIZE.TABLET)

  const createSystemProcess = () => showModal()

  if (isTablet) {
    return null
  }

  return (
    <IconButton data-testid='open-system-processes' onClick={createSystemProcess} description='System Processes'>
      <SystemProcessesIcon color='inherit' />
    </IconButton>
  )
}

export default AddSystemProcessesButton
